import React from "react"
import { useTranslation } from "react-i18next"

import { AttachmentFile } from "~/api/types/AttachmentFile"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

export const Attachment: React.FC<AttachmentFile & { className?: string }> = ({
  className,
  title,
  link,
  format,
  sizeValue,
}) => {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <Heading className={styles.Title} like="h4">
        <Raw html={title} />
      </Heading>

      <div className={styles.Footer}>
        <a
          className={styles.Link}
          dangerouslySetInnerHTML={{ __html: t("AttachmentFile.Link.Name") }}
          href={link !== null ? link : "#!"}
          rel="noopener noreferrer"
          target="_blank"
        />{" "}
        <span>
          {format}, {sizeValue}
        </span>
      </div>
    </div>
  )
}
